import { useState } from "react";
import axios from "axios";
import config from "config/config";

const useSendEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [error, setError] = useState(null);

  const formatBasketItemsToHTML = (basket) => {
    let html = '<table border="1" cellpadding="5" cellspacing="0">';
    html += '<tr><th>Product Code</th><th>Product Description</th></tr>';
  
    Object.keys(basket).forEach(itemCode => {
      const { details, description } = basket[itemCode];
      // const description = details && details.Description ? details.Description : 'Description not available';
      html += `<tr>
        <td>${itemCode}</td>
        <td>${description}</td>
      </tr>`;
    });
  
    html += '</table>';
    return html;
  };
  

  const formatFormDataToHTML = (formData) => {
    const { firstName, lastName, email, company, message } = formData;

    return `
      <p><strong>First Name:</strong> ${firstName}</p>
      <p><strong>Last Name:</strong> ${lastName}</p>
      <p><strong>Email:</strong> ${email}</p>
      <p><strong>Company:</strong> ${company}</p>
      <p><strong>Message:</strong> ${message}</p>
      <p><strong>Products:</strong></p>
    `;
  };

  const sendEmail = async (formData, basket) => {
    setIsLoading(true);
    setIsSuccess(null);
    setError(null);

    const { captchaToken, website, ...emailFormData } = formData;
    const basketHTML = formatBasketItemsToHTML(basket);
    const formHTML = formatFormDataToHTML(emailFormData);

    try {
      await axios.post(`${config.API_BASE_URL}/send-email`, {
        ...emailFormData,
        captchaToken,
        website,
        html: formHTML + basketHTML,
        subject: emailFormData.company ? `Inquiry form / Akyga battery x ${emailFormData.company}` : "Inquiry form / Akyga battery",
        email: emailFormData.email,
        supportEmail: "sales@akygabattery.com"
      });
      setIsSuccess(true);
      // console.log('Email sent:', response.data);
    } catch (err) {
      setIsSuccess(false);
      setError(err);
      console.error('There was an error sending the email:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return { sendEmail, isLoading, isSuccess, error };
};

export default useSendEmail;
